import Cookies from 'js-cookie'

const CONFIG_KEY = '_tndrs_config'

const AppStorage = {
  getToken() {
    if (typeof localStorage !== 'undefined') {
      return this.get('_token')
    }
    return Cookies.get('_token')
  },
  setToken(value) {
    if (typeof localStorage !== 'undefined') {
      this.set('_token', value)
    } else {
      Cookies.set('_token', value)
    }
  },
  getLocale() {
    if (typeof localStorage !== 'undefined') {
      return localStorage.getItem('_locale')
    }
    return Cookies.get('_locale')
  },
  setLocale(value) {
    if (typeof localStorage !== 'undefined') {
      return localStorage.setItem('_locale', value)
    }
    Cookies.set('_locale', value)
    return true
  },
  get(key) {
    let object = localStorage.getItem(CONFIG_KEY)
    if (object) {
      object = JSON.parse(object)
    } else {
      object = {}
    }

    return object[key] || false
  },
  set(key, value) {
    let object = localStorage.getItem(CONFIG_KEY)
    if (object) {
      object = JSON.parse(object)
    } else {
      object = {}
    }
    object[key] = value
    localStorage.setItem(CONFIG_KEY, JSON.stringify(object))
    return true
  },
  increase(key) {
    let object = localStorage.getItem(CONFIG_KEY)
    if (object) {
      object = JSON.parse(object)
    } else {
      object = {}
    }
    object[key] = object[key] ? parseInt(object[key], 10) + 1 : 1
    localStorage.setItem(CONFIG_KEY, JSON.stringify(object))
    return true
  },
  setBigData(key, value) {
    if (typeof localStorage === 'undefined') {
      return
    }
    localStorage.setItem(key, JSON.stringify(value))
  },
  getBigData(key, defaultObj) {
    if (typeof localStorage === 'undefined') {
      return defaultObj
    }
    let object = localStorage.getItem(key)
    if (object) {
      object = JSON.parse(object)
    } else {
      object = defaultObj || {}
    }
    return object
  },
  setLocaleData(key, value) {
    const localeKey = key + Storage.get('_locale')
    localStorage.setItem(localeKey, JSON.stringify(value))
    return true
  },
  getLocaleData(key, defaultObj) {
    if (key === 'optionsv') {
      return defaultObj
    }
    const localeKey = key + Storage.get('_locale')
    let object = localStorage.getItem(localeKey)
    if (object) {
      object = JSON.parse(object)
    } else {
      object = defaultObj || {}
    }
    return object
  },
  saveToSessionStorage(key, value) {
    if (typeof window !== 'undefined') {
      sessionStorage.setItem(key, JSON.stringify(value))
    }
  },
  loadFromSessionStorage(key) {
    if (typeof window !== 'undefined' && sessionStorage.getItem(key) !== null) {
      const value = sessionStorage.getItem(key)
      return value && value !== 'undefined' ? JSON.parse(value) : null
    }
    return null
  },
  clearFromSessionStorage(key) {
    try {
      sessionStorage.removeItem(key)
    } catch (e) {
      // handle catch
    }
  }
}

export default AppStorage
